const PERIODICIDADE = {
    DIARIA: { id: 'D', descricao: 'Diária', index: 1 },
    SEMANAL: { id: 'S', descricao: 'Semanal', index: 2 },
    MENSAL: { id: 'M', descricao: 'Mensal', index: 3 },
    ANUAL: { id: 'A', descricao: 'Anual', index: 4 },
    IRREGULAR: { id: 'I', descricao: 'Irregular', index: 5 },
    EMISSAO: { id: 'E', descricao: 'Emissão', index: 6 },
    VENCIMENTO: { id: 'V', descricao: 'Vencimento', index: 7 }
};

module.exports = PERIODICIDADE;

// Enum DBCnsPeriodicidade
//     Diaria = 1
//     Mensal = 2
//     Anual = 3
//     Irregular = 4
// End Enum
